<template>
  <vs-card style="min-height: 120px;">
    <vs-row>
      <vs-col>
        <table class="sticky-table w-full mt-4">
          <thead>
            <tr class="sticky-table-tr">
              <th style="width: 20vw;" class="sticky-table-th text-left"> {{ $t('departament') | capitalize }}</th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> {{ month != '' ? month : '-' | capitalize }} </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Acumulado a {{ month != '' ? month : '-' | capitalize }}
              </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Presupuesto Mensual </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Presupuesto Acumulado </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Variación Absoluta </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Variación Porcentual % ({{ month != '' ? month : '-' |
                capitalize }}) </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Variación Absoluta Acumulada </th>
              <th style="width: 10vw;" class="sticky-table-th text-center"> Variación Porcentual % (Acumulada) </th>
            </tr>
          </thead>

          <tbody id="table-loading" class="vs-con-loading__container">
            <tr :key="indextr" v-for="(item, indextr) in filtered" class="sticky-table-tr">
              <td class="sticky-table-td">
                {{ item.name }}
              </td>
              <td  class="sticky-table-td text-right">
                {{ formatCell(item.expense_total_month, '$') }}
              </td>
              <td  class="sticky-table-td text-right">
                {{ formatCell(item.expense_accumulated, '$') }}
              </td>
              <td class="sticky-table-td text-right">
                {{ formatCell(item.budget_total_month, '$') }}
              </td>
              <td  class="sticky-table-td text-right">
                {{ formatCell(item.budget_accumulated, '$') }}
              </td>
              <td
                :class="[getBackground(item.expense_total_month, item.budget_total_month), 'text-right','sticky-table-td']">
                {{ formatCell(item.variation_month, '$') }}
              </td>
              <td 
                :class="[getBackground(item.expense_total_month, item.budget_total_month), 'text-right','sticky-table-td']">
                {{ formatCell(item.variation_porcentage_month, '%') }}
              </td>
              <td
                :class="[getBackground(item.expense_accumulated, item.budget_accumulated), 'text-right','sticky-table-td']">
                {{ formatCell(item.variation_accumulated, '$') }}
              </td>
              <td
                :class="[getBackground(item.expense_accumulated, item.budget_accumulated), 'text-right','sticky-table-td']">
                {{ formatCell(item.variation_porcentage_accumulated, '%') }}
              </td>
            </tr>

            <tr style="font-size: 1.5em;" v-if="filtered.length > 0" class="sticky-table-tr">
              <td class="sticky-table-td text-right">
                <span class="font-bold">{{ $t('total') | capitalize }} </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('expense_total_month'), '$') }}
                </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('expense_accumulated'), '$') }}
                </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('budget_total_month'), '$') }}
                </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('budget_accumulated'), '$') }}
                </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold"> {{ formatCell(getTotal('variation_month'), '$') }} </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('variation_porcentage_month'), '%') }}
                </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('variation_accumulated'), '$') }}
                </span>
              </td>
              <td class="sticky-table-td text-right">
                <span class="font-bold">
                  {{ formatCell(getTotal('variation_porcentage_accumulated'), '%') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </vs-col>
    </vs-row>
  </vs-card>


</template>
<script>
import loading from '@/mixins/Loading'

export default {
  components: {},
  computed: {
    filtered() {
      return this.data.filter((el) => el.name.toLowerCase().includes(this.text.toLowerCase().trim()))
    },
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    getTotal(column) {
      return this.filtered.reduce((a, c) => Number(a) + Number(c[column]), 0)
    },
    formatCell(value, sim) {
      if (value == '0') {
        return '-'
      }
      return `${sim == '$' ? '$' : ''} ${this.formatNumber(value, 2)} ${sim == '%' ? '%' : ''}`
    },
    getBackground(value1, value2) {
      const x = Number(value1)
      const y = Number(value2)
      if (x == '0' && y == '0') {
        return 'col-grey';
      }
      if (x > y) {
        return 'col-danger';
      }
      if (x <= y) {
        return 'col-success';
      }
    }
  },
  mixins: [loading],
  watch: {
    loading(val) {
      if (val) {
        this.openLoading('table-loading')
      } else {
        this.closeLoading('table-loading')
      }
    },
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    month: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
.col-success {
  background: #28c76f;
  color: #ffffff;
}

.col-danger {
  background: #bc1300;
  color: #ffffff;
}

.col-grey {
  background: #b8c2cc;
  color: #000000;
}
</style>
